import { Breadcrumbs, TextField } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import AddComment from "@material-ui/icons/AddComment";
import AssignmentIcon from "@material-ui/icons/Assignment";
import SendIcon from "@material-ui/icons/Send";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Chart from "../Components/TemperatureChart";
import Title from "../Components/Title";
import { showPopupSnackbar } from "../redux/actions/snackbarActions";
import { formatTimeWithTZOffset, getToken } from "../Utils/Common";
import EnvSettings from "../Utils/EnvSettings";
import { useStyles } from "../Utils/Styles";

const server = EnvSettings.server;

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function formatChartData(data) {
  var retdata = [];
  data.forEach((element) => {
    retdata.push({
      tempOne:
        element.tempOne && element.tempOne !== 8500
          ? element.tempOne / 100.0
          : null,
      tempTwo:
        element.tempTwo && element.tempTwo !== 8500
          ? element.tempTwo / 100.0
          : null,
      tempThree:
        element.tempThree && element.tempThree !== 8500
          ? element.tempThree / 100.0
          : null,
      timeStamp: formatTimeWithTZOffset(element.timeStamp),
    });
  });
  return retdata;
}

export default function TransportDetails(props) {
  const classes = useStyles();
  const [chartData, setChartData] = useState();
  const [chartSize, setChartSize] = useState();
  const [showLoader, setShowLoader] = useState(false);
  const { t } = useTranslation();
  const [noteText, setNoteText] = useState();
  const [showAddNote, setShowAddNote] = useState();
  const dispatch = useDispatch();
  const [editDescription, setEditDescription] = useState(false);
  const [descriptionText, setDescriptionText] = useState();
  const history = useHistory();

  let chartRef = React.useRef();

  let createReport = async (e) => {
    if (!chartData.Measurements.length) {
      return;
    }
    if (process.env.NODE_ENV !== "production") {
      console.log(e.current);
    }
    setShowLoader(true);
    setChartSize(500);
    await sleep(2000);
    history.push(
      "/report/transport/" + props.computedMatch.params.transport_id
    );
  };

  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

  let getChartData = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        transportid: props.computedMatch.params.transport_id,
      }),
    };
    fetch(server + "/get_transportation_data", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        if (process.env.NODE_ENV !== "production") {
          console.log(result);
        }
        if (result.error) {
          dispatch(showPopupSnackbar(result));
        } else {
          setChartData(result.transport);
        }
      });
  };

  let changeDescription = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        transportid: props.computedMatch.params.transport_id,
        description: descriptionText,
      }),
    };
    fetch(server + "/change_description", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        if (process.env.NODE_ENV !== "production") {
          console.log(result);
        }
        if (result.error) {
          dispatch(showPopupSnackbar(result));
        } else {
          getChartData();
          setEditDescription(false);
        }
      });
  };

  let addNote = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        transportid: props.computedMatch.params.transport_id,
        note: noteText,
      }),
    };
    fetch(server + "/add_note", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        if (process.env.NODE_ENV !== "production") {
          console.log(result);
        }
        if (result.error) {
          dispatch(showPopupSnackbar(result));
        } else {
          getChartData();
          setNoteText("");
        }
      });
  };

  useEffect(getChartData, []);

  return (
    <Grid container spacing={3}>
      <Grid item xs>
        {chartData ? (
          <Breadcrumbs aria-label="breadcrumb">
            <Link color="inherit" href="/devices">
              {t("transportDetails.devices")}
            </Link>
            <Link color="inherit" href={`/devices/${chartData.Device.id}`}>
              {chartData
                ? "Medibag " + chartData.Device.serialNumber
                : undefined}
            </Link>
            <Typography color="textPrimary">{`${t(
              "transportDetails.transport"
            )}`}</Typography>
          </Breadcrumbs>
        ) : undefined}
      </Grid>

      <Grid item xs={12}>
        <Paper>
          <Button
            onClick={() => {
              createReport(chartRef);
            }}
            //href={'/report/'+props.computedMatch.params.transport_id} target="_blank"
          >
            <AssignmentIcon />
            <Typography>{t("transportDetails.downloadPDF")}</Typography>
          </Button>
        </Paper>
      </Grid>
      <Grid item xs>
        <Paper className={classes.paper}>
          {editDescription ? (
            <TextField
              name="description"
              variant="outlined"
              required
              value={descriptionText}
              fullWidth
              id="description"
              label={t("transportDetails.description")}
              onChange={(e) => setDescriptionText(e.target.value)}
              onBlur={() => {
                changeDescription();
              }}
            />
          ) : (
            <Link
              style={{ cursor: "pointer" }}
              onClick={() => {
                setDescriptionText(chartData.description);
                setEditDescription(true);
              }}
            >
              <Title>
                {chartData && chartData.description
                  ? chartData.description
                  : t("transportDetails.addDescription")}
              </Title>
            </Link>
          )}
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper
          ref={chartRef}
          className={fixedHeightPaper}
          style={chartSize ? { width: chartSize } : undefined}
        >
          {chartData ? (
            <Chart
              data={{
                chartData: formatChartData(chartData.Measurements),
                title: formatTimeWithTZOffset(chartData.startTime),
                deviceConfig: chartData.Device.DeviceConfig,
              }}
            />
          ) : undefined}
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Title>{t("transportDetails.notes")}</Title>
          <Grid container direction={"column"}>
            {chartData?.Notes.map((row) => (
              <Grid
                container
                direction={"row"}
                style={{
                  padding: 5,
                  borderBottomColor: "black",
                  borderBottomWidth: 1,
                  borderBottomStyle: "solid",
                }}
              >
                <Grid item xs={2}>
                  <Typography>{row.User.fullName}</Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography>
                    {formatTimeWithTZOffset(row.createdAt)}
                  </Typography>
                </Grid>
                <Grid item xs>
                  <Typography>{row.text}</Typography>
                </Grid>
              </Grid>
            ))}
          </Grid>
          <Button
            onClick={() => {
              setShowAddNote(!showAddNote);
            }}
          >
            <AddComment></AddComment>
            <Typography>{t("transportDetails.addNote")}</Typography>
          </Button>
          {showAddNote ? (
            <Grid container style={{ flexDirection: "row" }}>
              <Grid item xs={11}>
                <TextField
                  name="note"
                  variant="outlined"
                  required
                  value={noteText}
                  fullWidth
                  id="note"
                  label={t("transportDetails.note")}
                  onChange={(e) => setNoteText(e.target.value)}
                />
              </Grid>
              <Grid item xs={1} style={{ alignItems: "center" }}>
                <Button
                  onClick={() => {
                    addNote();
                  }}
                >
                  <SendIcon></SendIcon>
                </Button>
              </Grid>
            </Grid>
          ) : undefined}
        </Paper>
      </Grid>
      <div
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          width: "100%",
          height: "2000px",
          zIndex: 10000,
          backgroundColor: "#FFF",
          display: showLoader ? "inherit" : "none",
        }}
      >
        <Typography style={{ position: "absolute", left: "50%", top: 100 }}>
          Loading...
        </Typography>
        <CircularProgress
          style={{ position: "absolute", left: "50%", top: 200 }}
        />
      </div>
    </Grid>
  );
}
